export const MAP_LIST = {
  //用户体系
  // 'login':'/api/user/login',
  // 'getSecurityCode':'/api/user/getSecurityCode',
  // 'modifyUserInfo':'/api/user/modifyUserInfo',
  // 'getUserInfo':'/api/user/getUserInfo',
  'login':'/api/new/user/login',
  'getSecurityCode':'/api/new/user/getSecurityCode',
  'modifyUserInfo':'/api/new/user/modifyUserInfo',
  'getUserInfo':'/api/new/user/getUserInfo',

  // 验证token是否有效
  'verifyToken':'/api/new/user/verifyToken',
// 获取解密key
  getKey: '/fetch/key'
};



//////////////////
// WEBPACK FOOTER
// ./static/js/ajaxMap.js
// module id = null
// module chunks = 